import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController, Content, Events } from 'ionic-angular';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { TranslateService } from '@ngx-translate/core';
import { EventProfilePage } from '../event-profile/event-profile';
import { EventStands } from '../event-stands/event-stands';

@Component({
  selector: 'page-event',
  templateUrl: 'event.html'
})

export class EventPage {
  @ViewChild(Content) content: Content;

  obsBadgeCatalog: any;
  tokenEvent: String;
  event: any;
  eventList: any;
  client: any;
  textTranslate: any;
  badgeUser: any = [];
  // TODO: Esto se debe pasar a la bbdd
  menuLabels = {
    notes: 'Notas',
    social: 'Redes sociales',
    speaker: 'Conferencistas',
    opinometer: 'Opinómetro',
    map: 'Mapa',
    diary: 'Agenda',
    networking: 'Networking',
    catalog: 'Catálogo',
    resource: 'Recursos',
    question: 'Preguntas',
    profile: 'Mi Perfil',
    stands: 'Muestra comercial'
  };

  /**
   *
   * @param navCtrl
   * @param auth
   * @param params
   * @param alertCtrl
   */
  constructor(public navCtrl: NavController, public params: NavParams, public alertCtrl: AlertController, public loading: LoadingController, public toast: ToastController, translate: Translate, public translateProvider: TranslateService, public auth: AuthData, public eventProvider: EventData, public events: Events) {

    translate.translateGroup(["El módulo se encuentra inactivo en este momento", "Cargando", "Ok", "No se han encontrado opinómetros disponibles"]).then(data => {
      this.textTranslate = data;
    });

    this.event = this.params.get('event');
    this.eventList = this.params.get('eventList');
    this.client = this.params.get('client');

    this.event.configMenu.menuUnoIcon = this.getIcon(this.event.configMenu.menuUno);
    this.event.configMenu.menuDosIcon = this.getIcon(this.event.configMenu.menuDos);
    this.event.configMenu.menuTresIcon = this.getIcon(this.event.configMenu.menuTres);
    this.event.configMenu.menuCuatroIcon = this.getIcon(this.event.configMenu.menuCuatro);
    this.event.configMenu.menuCincoIcon = this.getIcon(this.event.configMenu.menuCinco);
    this.event.configMenu.menuSeisIcon = this.getIcon(this.event.configMenu.menuSeis);

    events.subscribe('client:login', () => {
      this.getBadgeUser();
    });

    // close de listener where logout user
    events.subscribe('client:logout', () => {
      this.closeListener();
    });
  }

  go(page) {
    let toast = this.toast.create({
      duration: 5000,
      position: 'top',
      closeButtonText: this.textTranslate['Ok'],
      showCloseButton: true
    });

    switch (page) {
      case 'diary':
      case 'social':
      case 'map':
      case 'networking':
      case 'speaker':
      case 'catalog':
        this.scrollToElement(page);
        break;
      case 'resource':
        // TODO: terminar
        break;
      case 'notes':
        let btnNote = document.getElementById('noteNow');
        if (btnNote) {
          btnNote.click();
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
      case 'question':
        let btnQuestion = document.getElementById('questionNow');
        if (btnQuestion) {
          btnQuestion.click();
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
      case 'opinometer':
        let btnOpinometer = document.getElementById('opinometerNow');
        if (btnOpinometer) {
          btnOpinometer.click();
        } else {
          toast.setMessage(this.textTranslate['No se han encontrado opinómetros disponibles']);
          toast.present();
        }
        break;
      case 'profile':
        this.viewProfile();
        break;
      case 'stands':
        if (this.event.modules.stands) {
          this.navCtrl.push(EventStands, { client: this.client, event: this.event });
        } else {
          toast.setMessage(this.textTranslate['El módulo se encuentra inactivo en este momento']);
          toast.present();
        }
        break;
    }
  }

  getIcon(page) {
    let icon: any;

    switch (page) {
      case 'diary':
        icon = 'md-calendar';
        break;
      case 'social':
        icon = 'ios-contacts';
        break;
      case 'speaker':
        icon = 'md-people';
        break;
      case 'map':
        icon = 'md-map';
        break;
      case 'networking':
        icon = 'md-people';
        break;
      case 'catalog':
        icon = 'md-pricetag';
        break;
      case 'notes':
        icon = 'md-create';
        break;
      case 'resource':
        icon = 'md-photos';
        break;
      case 'question':
        icon = 'md-help';
        break;
      case 'opinometer':
        icon = 'stats';
        break;
      case 'profile':
        icon = 'md-person';
        break;
      case 'stands':
        icon = 'md-pricetags';
        break;
    }

    return icon;
  }

  scrollToElement(id) {
    var el = document.getElementById(id);
    var rect = el.getBoundingClientRect();
    var posElement = (this.content.getContentDimensions().scrollTop + rect.top) - 50;
    this.content.scrollTo(0, posElement, 600);
    // TODO: bug if not module exist
  }

  viewProfile() {
    this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
  }

  getBadgeUser() {
    if (!this.auth.getUser().isAnonymous) {
      this.obsBadgeCatalog = this.eventProvider.getUser(this.client, this.auth.getUser().uid).subscribe((data: any) => {
        this.events.publish('catalog:badge', data.numCartPending);
        this.badgeUser = 0;

        if (data.numRequestNetworking) {
          // console.log(data.numRequestNetworking)
          this.badgeUser += data.numRequestNetworking;
        }

        if (data.numCartPending) {
          // console.log(data.numCartPending)
          this.badgeUser += data.numRequestNetworking;
        }
      });
    }
  }

  closeListener() {
    if (this.obsBadgeCatalog) {
      console.log('Se eliminan los observables de Badge catalogs');
      this.obsBadgeCatalog.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event/event.ts